import defaultPalette from '../palette';
export default (function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var _r = _a.palette, palette = _r === void 0 ? defaultPalette : _r;
    return {
        MuiChip: {
            root: {
                '&.active': {
                    backgroundColor: (_b = palette === null || palette === void 0 ? void 0 : palette.success) === null || _b === void 0 ? void 0 : _b.light,
                    color: (_c = palette === null || palette === void 0 ? void 0 : palette.success) === null || _c === void 0 ? void 0 : _c.dark,
                },
                '&.info': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.core[100],
                    color: (_d = palette === null || palette === void 0 ? void 0 : palette.text) === null || _d === void 0 ? void 0 : _d.primary,
                },
                '&.pending': {
                    backgroundColor: (_e = palette === null || palette === void 0 ? void 0 : palette.warning) === null || _e === void 0 ? void 0 : _e.light,
                    color: (_f = palette === null || palette === void 0 ? void 0 : palette.warning) === null || _f === void 0 ? void 0 : _f.contrastText,
                },
                '&.danger': {
                    backgroundColor: (_g = palette === null || palette === void 0 ? void 0 : palette.error) === null || _g === void 0 ? void 0 : _g.light,
                    color: (_h = palette === null || palette === void 0 ? void 0 : palette.error) === null || _h === void 0 ? void 0 : _h.dark,
                },
                '&.new': {
                    backgroundColor: (_j = palette === null || palette === void 0 ? void 0 : palette.success) === null || _j === void 0 ? void 0 : _j.main,
                    color: (_k = palette === null || palette === void 0 ? void 0 : palette.success) === null || _k === void 0 ? void 0 : _k.contrastText,
                },
                '&.filter': {
                    backgroundColor: (_l = palette === null || palette === void 0 ? void 0 : palette.background) === null || _l === void 0 ? void 0 : _l.paper,
                    color: (_m = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _m === void 0 ? void 0 : _m.main,
                },
            },
            deleteIcon: {
                color: (_o = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _o === void 0 ? void 0 : _o.main,
                '&:hover': {
                    color: (_p = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _p === void 0 ? void 0 : _p.main,
                },
            },
            outlined: {
                border: "1px solid " + ((_q = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _q === void 0 ? void 0 : _q.main),
                '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.core[100],
                },
            },
            clickable: {
                '&$outlined': {
                    '&:hover': {
                        backgroundColor: palette === null || palette === void 0 ? void 0 : palette.core[100],
                    },
                },
            },
        },
    };
});
